window.navigation = {
    goToUrl: function (url) {
        location.href = url;
    }
};

// methods for managing custom browser events
window.events = {
    dispatch: function (eventName, args, target) {
        let element = window;
        if (target) {
            element = document.querySelector(target);
        }

        var customEventArgs = {};
        if (args != null) {
            customEventArgs.detail = args;
        }
        const event = new CustomEvent(eventName, customEventArgs);

        element.dispatchEvent(event);
    },
    subscribe: function (eventName, dotnetHelper, callbackFun, target, timeout) {
        let element = window;
        if (target) {
            element = document.querySelector(target);
        }

        element.addEventListener(
            eventName,
            (e) => {
                if (timeout) {
                    setTimeout(() => {
                        dotnetHelper.invokeMethodAsync(callbackFun, e.detail);
                    }, timeout);
                    return;
                }

                // todo: do we need to handle removing this listener
                dotnetHelper.invokeMethodAsync(callbackFun, e.detail);
            },
            false
        );
    }
};

// methods for managing modals
//
window.modals = {
    onInitialized: function (target, dotnetHelper) {
        const modalSelector = document.querySelector(target);

        modalSelector.addEventListener('shown.bs.modal',
            () => {
                dotnetHelper.invokeMethodAsync('onModalShown');
            });

        modalSelector.addEventListener('hidden.bs.modal',
            () => {
                dotnetHelper.invokeMethodAsync('onModalHidden');
            });
    },
    toggle: function (target, action, modalDismissButtonId) {

        return new Promise((resolve, reject) => {

            const modalSelector = document.querySelector(target);
            const modal = bootstrap.Modal.getOrCreateInstance(modalSelector)

            const handleEscapeKey = (event) => {
                if (event.key === "Escape") {
                    var element = document.activeElement;
                    if (element && element.blur) {
                        element.blur();
                    }
                    document.getElementById(modalDismissButtonId).click();
                }
            }

            if (action === 'show') {
                if (modal._isShown || modal._isTransitioning) {
                    //modal is already shown so just resolve
                    resolve();
                } else {
                    //modal isn't shown so add listener for show event
                    modalSelector.addEventListener('shown.bs.modal',
                        () => {
                            document.addEventListener("keydown", handleEscapeKey);
                            resolve();
                        }, {once: true});

                }

                modal.show();

            } else if (action === 'hide') {
                if (modal._isShown || modal._isTransitioning) {
                    //modal is shown so add listener for hide event
                    modalSelector.addEventListener('hidden.bs.modal', () => {
                        document.removeEventListener("keydown", handleEscapeKey);
                        resolve();
                    }, {once: true});


                } else {
                    //modal isn't shown so just resolve
                    resolve();
                }

                modal.hide();
            }
        });
    }
};

window.formSelect = {
    /**
     * Handles focus behavior for BaseFormSelect components; for use with the syncfusion dropdownlist component.
     * @param {string} elementId - The ID of the select element
     *
     * Determines if the dropdown list is inside a modal and if so, disables the focus trap of
     * the modal so the dropdown can be focused when opened.
     *
     * The dropdownlist will get rendered outside the content of the modal. When the modal is opened, it traps focus within its content
     *  and as a result the Syncfusion dropdownlist will immediately disappear after being shown.
     *
     *  This resolution is based on the following workaround:
     *  https://github.com/sweetalert2/sweetalert2/issues/374#issuecomment-268802123
     */
    initializeSelectFocus: function (elementId) {
        const selectElement = document.getElementById(elementId);
        if (!selectElement) return;

        // Find the closest modal parent if it exists
        const modalParent = selectElement.closest('.modal');

        if (modalParent) {
            // If we're in a modal, handle the focus behavior
            const modalId = modalParent.id;
            const modalElement = document.getElementById(modalId);

            if (modalElement) {
                const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
                modalElement.addEventListener('shown.bs.modal', (event) => {
                    modal._focustrap.deactivate();
                });
            }
        }
    }
}

// methods for managing interop for the Tabs component(s)
//
window.tabs = {
    __tabs: {},

    initialize: (elementId, dotNetHelper) => {
        let navTabsEl = document.getElementById(elementId);
        let triggerTabList = [].slice.call(navTabsEl.querySelectorAll('button.nav-link'));

        triggerTabList.forEach(function (tabEl) {
            window.tabs.__tabs[tabEl.id] = bootstrap?.Tab?.getOrCreateInstance(tabEl);


            tabEl?.addEventListener('show.bs.tab', (event) => {
                // event.target --> active tab
                // event.relatedTarget --> previous active tab (if available)
                dotNetHelper.invokeMethodAsync('bsShowTab', event.target?.id, event.relatedTarget?.id);
            });
            tabEl?.addEventListener('shown.bs.tab', (event) => {
                // event.target --> active tab
                // event.relatedTarget --> previous active tab
                dotNetHelper.invokeMethodAsync('bsShownTab', event.target?.id, event.relatedTarget?.id);
            });
            tabEl?.addEventListener('hide.bs.tab', (event) => {
                // event.target --> current active tab
                // event.relatedTarget --> new soon-to-be-active tab
                dotNetHelper.invokeMethodAsync('bsHideTab', event.relatedTarget?.id, event.target?.id);
            });
            tabEl?.addEventListener('hidden.bs.tab', (event) => {
                // event.target --> previous active tab
                // event.relatedTarget --> new active tab
                dotNetHelper.invokeMethodAsync('bsHiddenTab', event.relatedTarget?.id, event.target?.id);
            });
        });
    },
    show: (elementId) => {
        let tab = window.tabs.__tabs[elementId] ?? bootstrap?.Tab?.getOrCreateInstance(document.getElementById(elementId));
        tab?.show();
    },
    dispose: (elementId) => {
        let tab = window.tabs.__tabs[elementId] ?? bootstrap?.Tab?.getOrCreateInstance(document.getElementById(elementId));
        tab?.dispose();

        delete window.tabs.__tabs[elementId];
    }
}

window.utils = {
    disableChildElements: function (rootElementSelector) {
        let rootEl = document.querySelector(rootElementSelector);
        let childNodes = rootEl.getElementsByTagName('*');
        for (let node of childNodes) {
            node.disabled = true;
        }
    }
}

// Helpers for putting focus on the first visible, interactive field in a form or modal.
// Blazor components pass a "marker" element (by id) to scope where the search should start.
window.formFocus = {
    // Focuses the first enabled, visible input/textarea/select (or tabbable element)
    // found under the closest form (or modal) that contains the marker element.
    focusFirstEnabled: function (markerId) {
        if (!markerId) return;

        const rootMarker = document.getElementById(markerId);
        if (!rootMarker) return;

        // Returns true if the element is a focusable form control (or has a valid tabindex)
        // and is not disabled.
        function isEnabled(el) {
            if (!el) return false;
            if (el.disabled) return false;

            const tag = el.tagName?.toLowerCase();

            if (tag === "input") {
                const type = (el.type || "").toLowerCase();
                if (["hidden", "button", "submit", "reset", "image"].includes(type)) {
                    return false;
                }
            }

            // also allow focusable non-input wrappers used by component libraries
            // (e.g. div/span with tabindex).
            const tabIndex = el.getAttribute?.("tabindex");
            const isTabbable = tabIndex !== null && tabIndex !== "-1";

            return tag === "input" || tag === "textarea" || tag === "select" || isTabbable;
        }

        // Returns true if the element is rendered with size and not visually hidden.
        function isVisible(el) {
            if (!el) return false;
            const rect = el.getBoundingClientRect();
            if (rect.width === 0 || rect.height === 0) return false;
            const style = window.getComputedStyle(el);
            if (style.visibility === "hidden" || style.display === "none") return false;
            return true;
        }

        // Scans descendants of root and focuses the first element that is both enabled and visible.
        function findAndFocus(root) {
            if (!root) return;

            const candidates = root.querySelectorAll("input, textarea, select, [tabindex]");

            for (const el of candidates) {
                if (!isEnabled(el) || !isVisible(el)) continue;

                const isSyncfusionDate =
                    el.tagName?.toLowerCase() === "input" &&
                    el.closest?.(".e-datepicker, .e-date-range-wrapper, .e-datetimepicker");

                if (isSyncfusionDate) continue; // skip date pickers

                el.focus();
                return;
            }
        }

        // If inside a bootstrap modal, focus after the modal is actually shown
        // (content can render while modal is still hidden/transitioning).
        const modal = rootMarker.closest?.(".modal");
        if (modal) {
            const doFocus = () => {
                const formInModal = rootMarker.closest?.("form");
                findAndFocus(formInModal || modal);
            };

            // Checks whether the modal is actually visible to the user (not display:none / aria-hidden).
            const isModalVisible = () => {
                // The modal may always include the "show" class but be hidden via display:none.
                // So check computed style/aria rather than relying on classList.
                const style = window.getComputedStyle(modal);
                if (style.display === "none" || style.visibility === "hidden") return false;
                if (modal.getAttribute("aria-hidden") === "true") return false;
                return true;
            };

            if (isModalVisible()) {
                // Defer one frame so layout is stable after the modal becomes visible.
                requestAnimationFrame(doFocus);
            } else {
                modal.addEventListener("shown.bs.modal", () => requestAnimationFrame(doFocus), { once: true });
            }

            return;
        }

        // Prefer the nearest form; if somehow not inside a form, fall back to the whole document.
        const form = rootMarker.closest?.("form");
        if (form) {
            findAndFocus(form);
        } else {
            findAndFocus(document);
        }
    }
};

window.security = {
    getToken: async function () {
        return document.cookie
            .split("; ")
            .find(row => row.startsWith("XSRF-TOKEN="))
            .split("=")[1];
    }
}

window.tooltips = {
    addTooltips: function (id) {
        if (id) {
            let el = document.getElementById(id);
            return new bootstrap.Tooltip(el)
        }
    }
}

/**
 * Top nav priority+ navigation (tertiary navbar).
 *
 * Shows as many nav items as fit in one row; the rest go into a "More" dropdown.
 * Uses IntersectionObserver to detect what fits (no manual width/tolerance math),
 * then reserves space for the "More" pill so it stays inside the container.
 *
 * @see https://css-tricks.com/the-priority-navigation-pattern/
 * @see https://github.com/jayfreestone/priority-plus
 */
window.topNav = {
    /**
     * Starts a single measurement pass: determines how many nav items fit in the
     * container and invokes the Blazor callback with that count.
     *
     * Expects the container to already have all items rendered in one row with
     * overflow hidden (Blazor renders this during the "measuring" phase).
     *
     * @param {string} containerId - Id of the navbar-tertiary element (e.g. "navbar-tertiary").
     * @param {object} dotnetRef - Blazor DotNetObjectReference for the TopNavMenu component.
     * @param {string} callbackName - Name of the JSInvokable method to call with the visible count (e.g. "OnTopNavVisibleCount").
     */
    startPriorityNavMeasurement: function (containerId, dotnetRef, callbackName) {
        const container = document.getElementById(containerId);
        if (!container || !dotnetRef) return;
        const items = container.querySelectorAll('.nav-pills .nav-item');
        if (items.length === 0) {
            dotnetRef.invokeMethodAsync(callbackName, 0);
            return;
        }

        const itemCount = items.length;
        const visible = new Array(itemCount);
        for (let i = 0; i < itemCount; i++) visible[i] = true;
        let reported = false;
        let observerRef = null;

        /**
         * Measures the width of the "More" pill in the same styling context (zoom, font).
         * Uses a temporary off-screen element so the reserve stays correct at any zoom level.
         * @returns {number} Width in px to reserve for the "More" pill (measured width + small buffer), or fallback if measurement fails.
         */
        function measureMorePillWidth() {
            var pills = container.querySelector('.nav-pills');
            if (!pills) return 66;
            var phantom = document.createElement('li');
            phantom.className = 'nav-item';
            phantom.setAttribute('aria-hidden', 'true');
            phantom.style.cssText = 'position:absolute;left:-9999px;visibility:hidden;pointer-events:none';
            var link = document.createElement('a');
            link.className = 'nav-link dropdown-toggle';
            link.textContent = 'More';
            phantom.appendChild(link);
            pills.appendChild(phantom);
            var w = link.getBoundingClientRect().width;
            phantom.remove();
            return Math.ceil(w) + 8;
        }

        /**
         * Runs after the IntersectionObserver has had a chance to fire: computes the
         * visible count, applies the "More" pill reserve, and notifies Blazor.
         */
        function report() {
            if (reported) return;
            reported = true;
            if (observerRef) observerRef.disconnect();
            let count = itemCount;
            for (let i = 0; i < itemCount; i++) {
                if (!visible[i]) {
                    count = i;
                    break;
                }
            }
            var style = window.getComputedStyle(container);
            var paddingRight = parseFloat(style.paddingRight) || 0;
            var contentRight = container.getBoundingClientRect().right - paddingRight;
            var reservePx = measureMorePillWidth();
            // Ensure the last visible item leaves room for the "More" pill so it doesn't overflow
            while (count > 0) {
                var lastRight = items[count - 1].getBoundingClientRect().right;
                if (contentRight - lastRight >= reservePx) break;
                count--;
            }
            dotnetRef.invokeMethodAsync(callbackName, count);
        }

        observerRef = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    const idx = entry.target.getAttribute('data-priority-nav-index');
                    if (idx !== null) visible[parseInt(idx, 10)] = entry.isIntersecting && entry.intersectionRatio >= 1;
                });
            },
            { root: container, rootMargin: '0px', threshold: 1 }
        );

        for (let i = 0; i < items.length; i++) {
            items[i].setAttribute('data-priority-nav-index', String(i));
            observerRef.observe(items[i]);
        }

        // Defer report by two frames so IntersectionObserver has run and layout is stable
        requestAnimationFrame(function () {
            requestAnimationFrame(report);
        });
    },

    /**
     * Subscribes to container size changes so Blazor can re-run measurement on resize/zoom.
     * @param {string} containerId - Id of the navbar-tertiary element.
     * @param {object} dotnetRef - Blazor DotNetObjectReference.
     * @param {string} callbackName - JSInvokable to invoke on resize (e.g. "OnTopNavResize").
     */
    observeResize: function (containerId, dotnetRef, callbackName) {
        const container = document.getElementById(containerId);
        if (!container) return;
        const observer = new ResizeObserver(function () {
            dotnetRef.invokeMethodAsync(callbackName);
        });
        observer.observe(container);
        if (!window._topNavObservers) window._topNavObservers = {};
        window._topNavObservers[containerId] = observer;
    },

    /**
     * Stops observing the container for resize. Call from Blazor on component dispose.
     * @param {string} containerId - Id of the navbar-tertiary element.
     */
    disposeResizeObserver: function (containerId) {
        const observers = window._topNavObservers;
        if (observers && observers[containerId]) {
            observers[containerId].disconnect();
            delete observers[containerId];
        }
    }
};

window.menu = {
    _dismissHandlers: {},
    registerPrimarySubmenuDismiss: (menuItemElementId, dotnetRef, callbackMethod) => {
        window.menu.unregisterPrimarySubmenuDismiss(menuItemElementId);

        const handler = (event) => {
            const root = document.getElementById(menuItemElementId);
            if (!root || !root.classList.contains('submenu-open')) {
                return;
            }

            if (root.contains(event.target)) {
                return;
            }

            dotnetRef.invokeMethodAsync(callbackMethod);
        };

        document.addEventListener('pointerdown', handler, true);
        window.menu._dismissHandlers[menuItemElementId] = () => {
            document.removeEventListener('pointerdown', handler, true);
        };
    },
    unregisterPrimarySubmenuDismiss: (menuItemElementId) => {
        const disposer = window.menu._dismissHandlers?.[menuItemElementId];
        if (disposer) {
            disposer();
            delete window.menu._dismissHandlers[menuItemElementId];
        }
    },
    registerSecondaryNavDismiss: (primaryNavId, secondaryNavId, dotnetRef, callbackMethod) => {
        window.menu.unregisterSecondaryNavDismiss();

        const invokeDismiss = () => dotnetRef.invokeMethodAsync(callbackMethod);

        const navContains = (target) => {
            if (!(target instanceof Node)) {
                return false;
            }

            const primary = document.getElementById(primaryNavId);
            const secondary = document.getElementById(secondaryNavId);
            return !!(primary?.contains(target) || secondary?.contains(target));
        };

        const pointerHandler = (event) => {
            if (navContains(event.target)) {
                return;
            }

            invokeDismiss();
        };

        document.addEventListener('pointerdown', pointerHandler, true);
        window.menu._secondaryDismissHandler = () => {
            document.removeEventListener('pointerdown', pointerHandler, true);
        };
    },
    unregisterSecondaryNavDismiss: () => {
        const disposer = window.menu._secondaryDismissHandler;
        if (disposer) {
            disposer();
            delete window.menu._secondaryDismissHandler;
        }
    }
}

window.files = {
    // download a file from a stream
    // see: https://learn.microsoft.com/en-us/aspnet/core/blazor/file-downloads?view=aspnetcore-8.0#download-from-a-stream
    // used by FileDownloadService.DownloadFile
    download: async (fileName, contentStreamByReference) => {
        const arrayBuffer = await contentStreamByReference.arrayBuffer();
        const blob = new Blob([arrayBuffer]);
        const url = URL.createObjectURL(blob);
        const anchorElement = document.createElement('a');
        anchorElement.href = url;
        anchorElement.download = fileName ?? '';
        anchorElement.click();
        anchorElement.remove();
        URL.revokeObjectURL(url);
    }
}